import React from 'react';
import { PropTypes } from 'prop-types';
import getConfig from 'next/config';
import CardGridLayout from '../../../../CardGridLayout/CardGridLayout';
import Text from '../../../../BuildingBlocks/Text';
import { NoResultsContainer } from '../styles';

const {
  publicRuntimeConfig: { LODGELINK_CMS_URI }
} = getConfig();

function NoResults({ title, subtitle, suggestionList, suggestionLabel, analytics, phone }) {
  return (
    <NoResultsContainer>
      <Text.HeadingThird tagName="h6">{title}</Text.HeadingThird>
      <Text.CopyParagraph>{suggestionLabel}</Text.CopyParagraph>
      <div className="no-result-suggestions">
        {suggestionList.split(',').map(suggestion => (
          <Text.CopyParagraph tagName="li" key={suggestion}>
            {suggestion}
          </Text.CopyParagraph>
        ))}
      </div>
      <Text.HeadingFourth tagName="h6" color="quaternary">
        {subtitle}
      </Text.HeadingFourth>
      <div className="description-spacing">
        <Text.CopyParagraph noMargins>
          Call us at <b>{phone}</b> or
          <CardGridLayout.Link
            href={`${LODGELINK_CMS_URI}/contact-us`}
            target="_blank"
            onClick={event => {
              analytics.trackEvent('no-search-result-click', {
                clickID: 'contact-us',
                destinationUrl: event.target.getAttribute('href'),
                sectionName: 'contact us online'
              });
            }}
          >
            {' '}
            contact us online
          </CardGridLayout.Link>{' '}
          for more information
        </Text.CopyParagraph>
      </div>
    </NoResultsContainer>
  );
}

NoResults.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  suggestionLabel: PropTypes.string.isRequired,
  suggestionList: PropTypes.string.isRequired,
  analytics: PropTypes.shape({
    trackEvent: PropTypes.func
  }).isRequired
};

export default NoResults;
